/**
 * Shared social proof – seeded, deterministic values per product ID.
 * Used by product-enhancements.js (product page) and card-rating.js (collection cards).
 * Settings from ThemeSocialProofSettings JSON (injected by snippets/social-proof-settings.liquid).
 */
(function () {
  'use strict';

  const DEFAULTS = {
    ratingMin: 41,
    ratingMax: 49,
    ratingCountMin: 20,
    ratingCountMax: 210,
    unitsSoldMin: 120,
    unitsSoldMax: 950,
    lowStockMin: 3,
    lowStockMax: 12,
    liveViewersMin: 5,
    liveViewersMax: 28,
  };

  function getSettings() {
    try {
      const el = document.getElementById('ThemeSocialProofSettings');
      if (el && el.textContent) {
        return Object.assign({}, DEFAULTS, JSON.parse(el.textContent));
      }
    } catch (e) {}
    return DEFAULTS;
  }

  function mulberry32(seed) {
    return function () {
      let t = (seed += 0x6d2b79f5);
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  /**
   * Returns deterministic social proof values from product ID.
   * @param {string|number} pid - Product ID
   * @param {Object} [opts] - Override defaults (optional)
   * @returns {{ rating: number, ratingCount: number, unitsSold: number, lowStock: number, liveViewers: number }}
   */
  function getSeededSocialProof(pid, opts) {
    const cfg = opts ? Object.assign({}, getSettings(), opts) : getSettings();
    const seed = parseInt(pid, 10) || 0;
    const rng = mulberry32(seed);
    const next = (min, max) => min + rng() * (max - min + 1);

    return {
      rating: Math.round(next(cfg.ratingMin, cfg.ratingMax)) / 10,
      ratingCount: Math.floor(next(cfg.ratingCountMin, cfg.ratingCountMax)),
      unitsSold: Math.floor(next(cfg.unitsSoldMin, cfg.unitsSoldMax)),
      lowStock: Math.floor(next(cfg.lowStockMin, cfg.lowStockMax)),
      liveViewers: Math.floor(next(cfg.liveViewersMin, cfg.liveViewersMax)),
    };
  }

  window.getSeededSocialProof = getSeededSocialProof;
})();
